import { StoriesContainer } from "@components/C253_StoriesContainer/C253_StoriesContainer";
import { StoriesProvider } from "@components/C253_StoriesContainer/C253_StoriesProvider";
import { Nationality } from "@customTypes/Nationality";
import { ProgrammeDetails } from "@customTypes/programmeDetails";
import Head from "next/head";

export interface StoryPageProps {
  bodyContent?: any;
  profileSurname?: string;
  profileFirstName?: string;
  profilePhoto: any;
  profileNationality: Nationality;
  profileProgramme: { fields: ProgrammeDetails };
  profileIsAmbassador: boolean;
  profileIsScholar: boolean;
  tags: any;
}

export const StoryPage = (props: { content: StoryPageProps }) => {
  const { content } = props;

  function getTagValueByProp(
    prop: string,
    pageTags: Record<string, string> = {}
  ) {
    const values = Object.values(pageTags);
    const tagName = values.find((value) => value.split(":")[0] == prop);

    return tagName?.split(":")[1];
  }

  return (
    <StoriesProvider>
      <Head>
        <meta name="profilesurname" content={content.profileSurname || ""} />
        <meta name="profirstname" content={content.profileFirstName || ""} />
        <meta
          name="profilenationality"
          content={content.profileNationality?.fields?.nationality || ""}
        />
        <meta
          name="profileprogramme"
          content={content.profileProgramme?.fields?.programmeTitle || ""}
        />
        <meta
          name="profileisambassador"
          content={
            content.profileIsAmbassador ? "Ambassador" : "Student/Alumni"
          }
        />
        <meta
          name="profileisscholar"
          content={content.profileIsScholar ? "Scholar" : "Student/Alumni"}
        />
        <meta
          name="profilephotosmallurl"
          content={content.profilePhoto?.fields?.image?.fields?.file?.url || ""}
        />
        <meta
          name="studenttype"
          content={
            content.tags ? getTagValueByProp("studenttype", content.tags) : ""
          }
        />
      </Head>
      <StoriesContainer content={content} />
    </StoriesProvider>
  );
};

export default StoryPage;
